var RemovedMatchesModifier = /** @class */ (function () {
    function RemovedMatchesModifier(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }
    RemovedMatchesModifier.prototype.modify = function (content) {
        if (content.events === undefined) {
            return;
        }
        var matches = content.events.remove;
        if (matches !== undefined) {
            for (var i = 0; i < matches.length; i++) {
                matches[i] = this._modelKeyRepository.removeMatch(matches[i]);
            }
        }
    };
    return RemovedMatchesModifier;
}());
export default RemovedMatchesModifier;



// WEBPACK FOOTER //
// ./src/repositories/modifier/RemovedMatchesModifier.js